import React from "react";
import { ReactComponent as IcT12Logo } from "app/assets/icons/t12-logo.svg";
import "./footer.scss";

const PrivateFooter: React.FC = () => {
  return (
    <div className="private-footer">
      <a href="mailto:suport@think-12.com" type="button" className="contact-us-button">
        Contact Us
      </a>
      <label className="copyright-info">© Copyright ThinK-12 · {new Date().getFullYear()}</label>
      <div className="powered-by-info">
        <span>Powered by</span>
        <IcT12Logo />
      </div>
    </div>
  );
};

export default PrivateFooter;
